'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Promise = _interopDefault(require('babel-runtime/core-js/promise'));
var _classCallCheck = _interopDefault(require('babel-runtime/helpers/classCallCheck'));
var _createClass = _interopDefault(require('babel-runtime/helpers/createClass'));
var _typeof = _interopDefault(require('babel-runtime/helpers/typeof'));
var _Object$isFrozen = _interopDefault(require('babel-runtime/core-js/object/is-frozen'));
var _Object$freeze = _interopDefault(require('babel-runtime/core-js/object/freeze'));
var _Object$create = _interopDefault(require('babel-runtime/core-js/object/create'));
var _Object$keys = _interopDefault(require('babel-runtime/core-js/object/keys'));
var _regeneratorRuntime = _interopDefault(require('babel-runtime/regenerator'));
var _Number$parseInt = _interopDefault(require('babel-runtime/core-js/number/parse-int'));
var _WeakMap = _interopDefault(require('babel-runtime/core-js/weak-map'));

/**
 * @callback asyncFunction
 * @async
 * @return {Promise<*>}
 */

// array cbs
/**
 * @callback arrayCallback
 * @param {*} item
 * @param {number} index
 * @param {array<*>} array
 * @return {*}
 */

/**
 * @callback arrayCallbackBoolean
 * @param {*} item
 * @param {number} index
 * @param {array<*>} array
 * @return {boolean}
 */

/**
 * @callback arrayReduceCallback
 * @param {*} previousValue
 * @param {*} currentValue
 * @param {number} index
 * @param {array<*>} array
 * @return {*}
 */

// async array cbs
/**
 * @callback asyncArrayCallback
 * @param {*} item
 * @param {number} index
 * @param {array} array
 * @return {Promise<*>}
 */

/**
 * @callback asyncArrayCallbackBoolean
 * @param {*} item
 * @param {number} index
 * @param {array} array
 * @return {Promise<boolean>}
 */

/**
 * @callback asyncArrayReduceCallback
 * @param {*} previousValue
 * @param {*} currentValue
 * @param {number} index
 * @param {array} array
 * @return {Promise<*>}
 */

/**
 * Returns a new array containing only uniq entries. Alias: *unique*
 * @this array<*>
 * @return {array<*>}
 * @example
 * import {uniq} from 'js-utils';
 * [1, 1, 2, 3, 3]::uniq(); // [1, 2, 3]
 */
function uniq() {
  return this.filter(function (val, i, arr) {
    return arr.indexOf(val) === i;
  });
}
/**
 * Returns a new array containing the intersection between *this* and *arr*.
 * @this array<*>
 * @param {array<*>} arr the 2. array
 * @return {array<*>}
 * @example
 * import {intersection} from 'js-utils';
 * [1, 2, 3]::intersection([3, 2]); // [2, 3]
 */
function intersection(arr) {
  return this.filter(function (val) {
    return arr.indexOf(val) !== -1;
  });
}

/**
 * Checks if the array contains a value.
 * @this array<*>
 * @param {*} value value to search in the array
 * @return {boolean} true if value is in this
 * @example
 * import {contains} from 'js-utils';
 * [1, 2, 3]::contains(3); // true
 * [1, 2, 3]::contains(4); // false
 */
function contains(val) {
  return this.indexOf(val) !== -1;
}

/**
 * Flat array map (similar to arrays in perl). This function flattens only one
 * level of array nesting.
 * @this array<*>
 * @param {arrayCallback} cb
 * @param {*} [thisArg] *this* to call *cb* with
 * @return {array<*>}
 * @example
 * import {flatMap} from 'js-utils';
 * [1, 2, 3]::flatMap(v => [v, 2 * v]); // [1, 2, 2, 4, 3, 6]
 */
function flatMap(cb, thisArg) {
  var ret = [];

  this.forEach(function (v, i, arr) {
    var r = cb.call(thisArg, v, i, arr);
    if (Array.isArray(r)) {
      ret.push.apply(ret, r); // no array spread due to overhead
    } else if (r !== null && r !== undefined) {
        ret.push(r);
      }
  });

  return ret;
}

/**
 * **Async**hronous **coll**ection offers some functions you already know
 * from JSs *array* class, but with support for *Promise*s.
 * @class AsyncColl
 * @example
 * import {asyncColl} from 'js-utils';
 * const values = await asyncColl(urls)
 *   .map(url => loadAsync(url))
 *   .filter(data => data.item > 2)
 *   .values();
 */
var AsyncColl = function () {
	/**
  * @param {Promise} p
  */

	function AsyncColl(p) {
		_classCallCheck(this, AsyncColl);

		this.promise = p;
	}

	/**
  * map values
  * @param {asyncArrayCallback} cb
  * @param {*} [thisArg] *this* to call *cb* with
  * @return {AsyncColl} returns a new instance of *AsyncColl*
  */


	_createClass(AsyncColl, [{
		key: 'map',
		value: function map(cb, thisArg) {
			var retP = this.promise.then(function (arr) {
				var ps = arr.map(cb, thisArg);
				return _Promise.all(ps);
			});
			return new AsyncColl(retP);
		}

		/**
   * filter values
   * @param {asyncArrayCallbackBoolean} cb
   * @param {*} [thisArg] *this* to call *cb* with
   * @return {AsyncColl} returns a new instance of *AsyncColl*
   */

	}, {
		key: 'filter',
		value: function filter(cb, thisArg) {
			var retP = this.promise.then(function (arr) {
				var ps = arr.map(function (item, index, array) {
					return _Promise.resolve(cb.call(thisArg, item, index, array)).then(function (res) {
						return [res, item];
					});
				});
				return _Promise.all(ps);
			}).then(function (items) {
				var ret = [];
				for (var i = 0; i < items.length; ++i) {
					if (items[i][0]) {
						ret.push(items[i][1]);
					}
				}
				return ret;
			});
			return new AsyncColl(retP);
		}

		/**
   * reverse values
   * @return {AsyncColl} returns a new instance of *AsyncColl*
   */

	}, {
		key: 'reverse',
		value: function reverse() {
			var retP = this.promise.then(function (arr) {
				return arr.slice().reverse();
			});
			return new AsyncColl(retP);
		}

		/**
   * reduce values
   * @param {asyncArrayReduceCallback} cb
   * @param {*} [initVal] initial reduce value
   * @return {AsyncColl} returns a new instance of *AsyncColl*
   * @throws {TypeError} if no *initVal* given and the array is empty
   */

	}, {
		key: 'reduce',
		value: function reduce(cb, initValArg) {
			return this.promise.then(function (arr) {
				var i = 0;

				var initVal = initValArg;
				if (!initVal) {
					if (arr.length === 0) {
						throw new TypeError('Empty array given');
					}

					initVal = arr[0];
					i = 1;
				}

				var p = _Promise.resolve(initVal);

				var _loop = function _loop() {
					var curI = i;
					/* eslint no-loop-func: 0 */
					p = p.then(function (lastVal) {
						return _Promise.resolve(cb(lastVal, arr[curI], curI, arr));
					});
				};

				for (; i < arr.length; ++i) {
					_loop();
				}

				return p;
			});
		}

		/**
   * reduce right values
   * @param {asyncArrayReduceCallback} cb
   * @param {*} [initVal] initial reduce value
   * @return {AsyncColl} returns a new instance of *AsyncColl*
   * @throws {TypeError} if no *initVal* given and the array is empty
   */

	}, {
		key: 'reduceRight',
		value: function reduceRight(cb, initVal) {
			return this.reverse().reduce(cb, initVal);
		}

		/**
   * iterates over values
   * @param {asyncArrayCallback} cb
   * @param {*} [thisArg] *this* to call *cb* with
   * @return {AsyncColl} returns a new instance of *AsyncColl*
   */

	}, {
		key: 'forEach',
		value: function forEach(cb, thisArg) {
			var retP = this.promise.then(function (arr) {
				var ps = arr.map(cb, thisArg);
				return _Promise.all(ps).then(function () {
					return arr;
				});
			});
			return new AsyncColl(retP);
		}

		/**
   * tests whether *every* values passes
   * @param {asyncArrayCallbackBoolean} cb
   * @param {*} [thisArg] *this* to call *cb* with
   * @return {AsyncColl} returns a new instance of *AsyncColl*
   */

	}, {
		key: 'every',
		value: function every(cb, thisArg) {
			return this.promise.then(function (arr) {
				var ps = arr.map(cb, thisArg);
				return _Promise.all(ps);
			}).then(function (arr) {
				for (var i = 0; i < arr.length; ++i) {
					if (!arr[i]) {
						return false;
					}
				}
				return true;
			});
		}

		/**
   * tests whether *some* values passes
   * @param {asyncArrayCallbackBoolean} cb
   * @param {*} [thisArg] *this* to call *cb* with
   * @return {AsyncColl} returns a new instance of *AsyncColl*
   */

	}, {
		key: 'some',
		value: function some(cb, thisArg) {
			return this.promise.then(function (arr) {
				var ps = arr.map(cb, thisArg);
				return _Promise.all(ps);
			}).then(function (arr) {
				for (var i = 0; i < arr.length; ++i) {
					if (arr[i]) {
						return true;
					}
				}
				return false;
			});
		}

		/**
   * returns values
   * @return {Promise<array<*>>} values
   */

	}, {
		key: 'values',
		value: function values() {
			return this.promise;
		}
	}]);

	return AsyncColl;
}();

/**
 * creates an {@link AsyncColl} object.
 * @param {array<*>} arr
 * @return {AsyncColl}
 * @throws {TypeError} if *arr* is not an array
 */
function asyncColl(arr) {
	if (!Array.isArray(arr)) {
		throw new TypeError('"' + arr + '" is not an array');
	}

	return new AsyncColl(_Promise.all(arr));
}

var objHasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * Filters keys from the *this* object.
 * @this object
 * @param {array|function} filter
 * @return {object} Object containing only the filtered keys.
 * @example
 * import {filterKeys} from 'js-utils';
 * {a: 1, b: 2, c: 3}::filterKeys(['b']); // {b: 2}
 * {a: 1, b: 2, c: 3}::filterKeys(k => k === 'b'); // {b: 2}
 */
function filterKeys(filter) {
	var _this = this;

	var keys = _Object$keys(this);
	if (Array.isArray(filter)) {
		var _context;

		keys = (_context = keys, intersection).call(_context, filter);
	} else if (typeof filter === 'function') {
		keys = keys.filter(filter);
	} else {
		throw new TypeError('Unsupported filter type "' + (typeof filter === 'undefined' ? 'undefined' : _typeof(filter)) + '"');
	}

	var ret = _Object$create(null);
	keys.forEach(function (key) {
		ret[key] = _this[key];
	});
	return ret;
}

/**
 * Checks if *this* is an object or a function.
 * @this object|function
 * @return {boolean} true if *this* is an object or a Function
 * @example
 * import {isObject} from 'js-utils';
 * {}::isObject(); // true
 * 42::isObject(); // false
 */
function isObject() {
	if (this === null) {
		return false;
	}
	var type = _typeof(this);
	return type === 'object' || type === 'function';
}

/**
 * deep freeze an object
 * @this object
 * @return {object} *this*
 * @throws {TypeError} if *this* is not an object
 * @example
 * import {deepFreeze} from 'js-utils';
 * const obj = {a: {b: 42}}::deepFreeze();
 * obj.a.b = 43; // error
 */
function deepFreeze() {
	if (!isObject.call(this)) {
		throw new TypeError('this "' + this + '" is not an object');
	}

	_Object$freeze(this);

	for (var key in this) {
		if (!objHasOwnProperty.call(this, key)) {
			continue;
		}

		var prop = this[key];
		if (isObject.call(prop) && !_Object$isFrozen(prop)) {
			deepFreeze.call(prop);
		}
	}

	return this;
}

/**
 * @param {asyncFunction} func async function
 * @throws rethrows exceptions throwen by the async function
 * @example
 * import {asyncMain} from 'js-utils';
 * asyncMain(async () => {
 *   // your main async program code
 *   await doAsyncThings();
 * });
 */
function asyncMain(func) {
  func().catch(function (e) {
    setTimeout(function () {
      throw e;
    }, 0);
  });
}

/**
 * Converts Node-style-callback async function to Promise returning one.
 * @param {function} cbFunc a Node-style-callback async function
 * @return {function} Promise returning async function
 * @example
 * import {toAsync} from 'js-utils';
 * function myCbFunc(a, b, cb) {
 *   return cb(null, a + b);
 * }
 *
 * const myAsyncFunc = toAsync(myCbFunc);
 * const res = await myAsyncFunc(1, 2);
 * console.log(res); // 3
 */
function toAsync(cbFunc) {
  var _this = this;

  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return new _Promise(function (resolve, reject) {
      return cbFunc.call.apply(cbFunc, [_this].concat(args, [function (err, res) {
        return err ? reject(err) : resolve(res);
      }]));
    });
  };
}

/**
 * Calls a node-style-callback async function and returns a Promise.
 * @async
 * @param {function|string} func node-style-callback async function or name
 * of a function in *this*
 * @param {...*} args function arguments
 * @return {Promise<*>}
 * @throws {TypeError}
 * @example
 * import {callNodeAsync} from 'js-utils';
 * function myCbFunc(a, b, cb) {
 *   return cb(null, `${a + b} - ${this}`);
 * }
 *
 * // simple function call
 * const res1 = await callNodeAsync(myCbFunc, 1, 2));
 * console.log(res1); // "3 - undefined"
 *
 * // simple function call with this
 * const res2 = await "foo"::callNodeAsync(myCbFunc, 1, 2));
 * console.log(res2); // "3 - foo"
 *
 * // method call
 * const myObj = {myCbFunc, toString() {return 'im an object';}};
 * const res3 = await myObj::callNodeAsync("myCbFunc", 1, 2));
 * console.log(res3); // "3 - im an object"
 */
function callNodeAsync(func) {
  var _this2 = this;

  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return new _Promise(function (resolve, reject) {
    var _cbFunc;

    var funcType = typeof func === 'undefined' ? 'undefined' : _typeof(func);
    var cbFunc = void 0;
    if (funcType === 'function') {
      cbFunc = func;
    } else if (funcType === 'string' && isObject.call(_this2) && func in _this2) {
      cbFunc = _this2[func];
    } else {
      return reject(new TypeError('unsupported function type or func not in this object'));
    }

    return (_cbFunc = cbFunc).call.apply(_cbFunc, [_this2].concat(args, [function (err, res) {
      return err ? reject(err) : resolve(res);
    }]));
  });
}

/**
 * Sleep for *ms* milliseconds.
 * @async
 * @param {number} ms time to sleep in milliseconds
 * @example
 * import {sleep} from 'js-utils';
 * await sleep(100); // "waits" for 100ms
 * console.log('foo'); // and prints "foo"
 */
function sleep(ms) {
  return new _Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}

/**
 * creates a random UUID (version 4).
 * @return {string} the UUID
 * @see {@link https://stackoverflow.com/a/8809472}
 * @example
 * import {uuid} from 'js-utils';
 * uuid(); // 967678aa-b7a3-48fa-a36d-9884ee204174
 */
function uuid() {
	var d = typeof Date.now === 'function' ? Date.now() : new Date().getTime();

	// hi-res in browser
	var brHiResAvl = typeof window !== 'undefined' && window.performance && typeof window.performance.now === 'function';
	if (brHiResAvl) {
		d += window.performance.now();
	}

	// hi-res in node
	if (typeof process !== 'undefined' && typeof process.hrtime === 'function') {
		d += process.hrtime()[1];
	}

	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		var r = (d + Math.random() * 16) % 16 | 0;
		d = Math.floor(d / 16);
		return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
	});
}

/* eslint-disable no-console */

/**
 * Wraps a function. When the wrapped function is called
 * an error is emitted *once*.
 * @function
 * @param {function} func the deprecated function
 * @param {string} [msg="{func.name} is deprecated"]
 * @return {function} wrapped *func*
 * @example
 * import {deprecate} from 'js-utils';
 * function deprecatedFunc() {}
 * export const func = deprecate(deprecatedFunc);
 */
exports.deprecate = void 0;

if (process.env.NODE_ENV !== 'production') {
	exports.deprecate = function deprecate(func) {
		var msg = arguments.length <= 1 || arguments[1] === undefined ? (func.name || 'unknown') + ' is deprecated' : arguments[1];

		var warned = false;

		return function $deprecate() {
			if (!warned) {
				var _context;

				(_context = console, console.warn || console.log).call(_context, msg);

				if (typeof console.trace === 'function') {
					console.trace();
				}

				warned = true;
			}

			return func.call.apply(func, [this].concat(Array.prototype.slice.call(arguments)));
		};
	};
} else {
	exports.deprecate = function deprecate(func) {
		return func;
	};
}

var _marked = [range].map(_regeneratorRuntime.mark);

/**
 * Returns a Generator over a range of numbers. Works in both directions.
 * @param {number} start The first yielded value; can be higher than end
 * @param {number} end The first *not* yielded value; can be lower than start
 * @param {number} [steps=1] The number of steps to take per interval; > 0
 * @return {Generator<number>}
 * @throws {TypeError} if steps <= 0
 */
function range(start, end) {
	var steps = arguments.length <= 2 || arguments[2] === undefined ? 1 : arguments[2];
	var i;
	return _regeneratorRuntime.wrap(function range$(_context) {
		while (1) {
			switch (_context.prev = _context.next) {
				case 0:
					if (!(steps < 0.00001)) {
						_context.next = 2;
						break;
					}

					throw new TypeError("steps \"" + steps + "\" <= 0");

				case 2:
					if (!(start < end)) {
						_context.next = 12;
						break;
					}

					i = start;

				case 4:
					if (!(i < end)) {
						_context.next = 10;
						break;
					}

					_context.next = 7;
					return i;

				case 7:
					i += steps;
					_context.next = 4;
					break;

				case 10:
					_context.next = 19;
					break;

				case 12:
					i = start;

				case 13:
					if (!(end < i)) {
						_context.next = 19;
						break;
					}

					_context.next = 16;
					return i;

				case 16:
					i -= steps;
					_context.next = 13;
					break;

				case 19:
				case "end":
					return _context.stop();
			}
		}
	}, _marked[0], this);
}

var META_CACHE = new _WeakMap();
var OPTION_REGEX = /^\:([a-z]+)\(([^\)]*)\)/;
var PLACEHOLDER_REGEX = /{([0-9]+)}/g;

function createMeta(literals) {
	var key = literals[0];
	var trans = [];
	for (var i = 1; i < literals.length; i += 1) {
		var literal = literals[i];

		var match = literal.match(OPTION_REGEX);
		if (match) {
			trans.push([match[1], JSON.parse(match[2])]);
		} else {
			trans.push(null);
		}

		var cleanedLiteral = match ? literal.replace(OPTION_REGEX, '') : literal;
		key += '{' + (i - 1) + '}' + cleanedLiteral;
	}

	return {
		key: key,
		fransforms: trans
	};
}

var I18n = function () {
	function I18n(cfg) {
		_classCallCheck(this, I18n);

		this.config(cfg);
	}

	_createClass(I18n, [{
		key: 'config',
		value: function config() {
			var cfg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

			this.messages = {};
			this.transformers = {};

			if (cfg.messages) this.messages = cfg.messages;
			if (cfg.transformers) this.transformers = cfg.transformers;
		}
	}, {
		key: 'i18nArr',
		value: function i18nArr(literals) {
			var meta = META_CACHE.get(literals);
			if (meta === undefined) {
				meta = createMeta(literals);
				META_CACHE.set(literals, meta);
			}

			var msgArr = [];
			var msg = this.messages[meta.key] || meta.key;
			var litStartIndex = 0;

			for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
				values[_key - 1] = arguments[_key];
			}

			for (;;) {
				var match = PLACEHOLDER_REGEX.exec(msg);
				if (match === null) break;

				msgArr.push(msg.substring(litStartIndex, match.index));
				litStartIndex = match.index + match[0].length;
				var i = _Number$parseInt(match[1], 10);

				var value = values[i];
				var trans = meta.fransforms[i];
				if (trans !== null) value = this.transformers[trans[0]].call(this, values[i], trans[1]);
				msgArr.push(value);
			}

			if (litStartIndex !== msg.length) msgArr.push(msg.substr(litStartIndex));

			return msgArr;
		}
	}, {
		key: 'i18n',
		value: function i18n(literals) {
			for (var _len2 = arguments.length, values = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
				values[_key2 - 1] = arguments[_key2];
			}

			return this.i18nArr.apply(this, [literals].concat(values)).join('');
		}
	}]);

	return I18n;
}();

var Lock = function () {
	function Lock() {
		_classCallCheck(this, Lock);

		this._queue = [];
		this._locked = false;
	}

	_createClass(Lock, [{
		key: 'lock',
		value: function lock(cfg) {
			var _this = this;

			return new _Promise(function (resolve, reject) {
				var released = false;
				var release = function release() {
					if (released) throw new Error('Lock already released');
					released = true;
					var next = _this._queue.shift();
					if (next === undefined) _this._locked = false;else next();
				};

				if (!_this._locked) {
					_this._locked = true;
					resolve(release);
				} else if (cfg && cfg.timeout) {
					(function () {
						var timeoutId = setTimeout(function () {
							reject(new Error('Lock timeout exceeded'));
							timeoutId = undefined;
						}, cfg.timeout);
						_this._queue.push(function () {
							if (timeoutId) {
								clearTimeout(timeoutId);
								timeoutId = undefined;
								resolve(release);
							} else {
								release();
							}
						});
					})();
				} else {
					_this._queue.push(function () {
						return resolve(release);
					});
				}
			});
		}
	}]);

	return Lock;
}();

var REGEX = /\S+/g;

/**
 * Splits up a string into words.
 * @param {string} str
 * @return {array<string>} words
 * @example
 * import {qw} from 'js-utils';
 * qw('aaa bbb ccc ddd'); // ['aaa', 'bbb', 'ccc', 'ddd']
 */
function qw(str) {
  return str.match(REGEX) || [];
}

/**
 * Splits up a string into words and uses them to build an object.
 * @param {string} str
 * @return {object} object
 * @throws {TypeError} if the word cound is not even
 * @example
 * import {qwm} from 'js-utils';
 * qwm(`aaa bbb
 *      ccc ddd`);
 * // {'aaa': 'bbb',
 * //  'ccc': 'ddd'}
 */
function qwm(str) {
  var arr = qw(str);

  if (arr.length % 2 !== 0) {
    throw new TypeError('Array length is not even.');
  }

  var ret = {};
  for (var i = 0; i < arr.length; i += 2) {
    ret[arr[i]] = arr[i + 1];
  }
  return ret;
}

/* eslint-disable no-console */

/**
 * prints *this*
 * @param {function} [logFunc=console.log] log function
 * @example
 * import {print} from 'js-utils';
 * "my string"::print();
 * @return {*} returns the return value from logFunc call
 */
function print() {
  var logFunc = arguments.length <= 0 || arguments[0] === undefined ? console.log : arguments[0];

  return logFunc(this);
}

exports.uniq = uniq;
exports.unique = uniq;
exports.intersection = intersection;
exports.contains = contains;
exports.flatMap = flatMap;
exports.AsyncColl = AsyncColl;
exports.asyncColl = asyncColl;
exports.asyncMain = asyncMain;
exports.toAsync = toAsync;
exports.callNodeAsync = callNodeAsync;
exports.sleep = sleep;
exports.uuid = uuid;
exports.range = range;
exports.I18n = I18n;
exports.Lock = Lock;
exports.filterKeys = filterKeys;
exports.isObject = isObject;
exports.deepFreeze = deepFreeze;
exports.qw = qw;
exports.qwm = qwm;
exports.print = print;
//# sourceMappingURL=js-utils.js.map
